import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { CardFooterTitle, TextOverflowTooltip } from "@opensea/ui-kit";
export const ItemCardNameFragment = graphql(`
  fragment ItemCardNameFragment on Item {
    name
  }
`);
export function ItemCardName(t0) {
  const $ = _c(5);
  const {
    className,
    item: itemKey
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(ItemCardNameFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  let t2;
  if ($[2] !== className || $[3] !== item.name) {
    t2 = <TextOverflowTooltip className="min-w-0 flex-1"><CardFooterTitle className={className} data-testid="ItemName">{item.name}</CardFooterTitle></TextOverflowTooltip>;
    $[2] = className;
    $[3] = item.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}